// removed by extract-text-webpack-plugin
module.exports = {"saml-idp-wrapper":"saml-idp-wrapper","samlIdpWrapper":"saml-idp-wrapper","section":"section","item-name":"item-name","itemName":"item-name","saml-idp-active":"saml-idp-active","samlIdpActive":"saml-idp-active","additional-details":"additional-details","additionalDetails":"additional-details","right":"right","edit-wrapper":"edit-wrapper","editWrapper":"edit-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/saml/idpItems/style.scss
// module id = 1445
// module chunks = 0